<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>
            Edit
            <p *ngIf="fulfillment" class="subtitle">Fulfillment #{{fulfillment.number}}</p>
        </ion-title>
        <ion-buttons *ngIf="online && !loading" slot="end">
            <ion-button (click)="update()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid *ngIf="online && !loading && fulfillment" class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row *ngIf="fulfillment.has_tangible_items == true">
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" (ionCancel)="clearCourier()" interface="alert" [interfaceOptions]="courier_options" labelPlacement="stacked" fill="outline" [(ngModel)]="params['courier_id']">
                                <div slot="label">Courier<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option *ngFor="let courier of couriers" value="{{courier.id}}">{{courier.title}}</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="fulfillment.has_tangible_items == true">
                        <ion-col>
                            <ion-input type="tel" inputmode="decimal" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['courier_tracking_number']">
                                <div slot="label">Courier tracking number<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="fulfillment.has_tangible_items == true">
                        <ion-col>
                            <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['customer_note']">
                                <div slot="label">Note to customer<ion-text class="optional">optional</ion-text></div>
                            </ion-textarea>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="fulfillment.has_tangible_items == true">
                        <ion-col>
                            <ion-item lines="none" class="ion-no-padding">
                                <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" [(ngModel)]="params.send_order_shipped_email">Send order shipped email</ion-toggle>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                    <ion-row >
                        <ion-col>
                            <ion-input *ngIf="params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" value={{formated_date}} (click)="presentDateTimePickerModal()"></ion-input>
                            <ion-input *ngIf="!params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>